export const DataFields = (t) => {
  return [
    {
      name: "",
      fields: [
        {
          id: "name",
          name: t('promotions_form_name'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "description",
          name: t('promotions_form_description'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "url",
          name: t('promotions_form_image'),
          type: "image",
          required: false,
          isImage: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "duration",
          name: t('promotions_form_duration'),
          type: "number",
          required: true,
          defaultValue: 3000,
          inputProps: { min: 1000, max: 60000 },
          endAdornment: { value: "ms" },
          startAdornment: null,
          size: "small"
        },
        {
          id: "validity_start_datetime",
          name: t('promotions_form_validity_start'),
          type: "datetimepicker",
          required: false,
          defaultValue: "",
          size: "small"
        },
        {
          id: "validity_end_datetime",
          name: t('promotions_form_validity_end'),
          type: "datetimepicker",
          required: false,
          defaultValue: "",
          size: "small"
        },
        {
          id: "active",
          name: t('promotions_form_active'),
          type: "switch",
          required: true,
          defaultValue: false,
          size: "small"
        },
      ]
    }
  ]
}